<div class="nav">
    <ul class="nav nav-pills nav-fill fixed-bottom px-1 py-2 d-flex justify-content-center">
        <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab === 0" (click)="navigateToTab(0)">
                <i class="fa fa-handshake"></i>
                <span class="tab-title"> {{ 'partner.list' | translate }} </span>
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab === 1" (click)="navigateToTab(1)">
                <i class="fas fa-table"></i>
                <span class="tab-title"> {{ 'partner.pivot' | translate }} </span>
            </a>
        </li>
    </ul>
</div>
<div class="container" (swipe)="onSwipe($event)">
    <div *ngIf="activeTab === 0">
        <div class="mt-0 p-0 p-xl-5 row bg-light border-top border-dark">
            <app-partner-list></app-partner-list>
        </div>
    </div>
    <div *ngIf="activeTab === 1">
        <div class="mt-0 p-0 p-xl-5 row bg-light border-top border-dark">
            <app-partner-report></app-partner-report>
        </div>
    </div>
</div>
